import { Flex } from '@chakra-ui/react';
import { useState } from 'react';

import { FormField, Switch, Text } from '@revelio/ui';

import {
  type CacheBypassFlags,
  getCacheBypassFlags,
  setCacheBypassFlag,
} from '../../../shared/data-fetch/cache-bypass-exchange';

export const CacheBypassOptions = () => {
  const [cacheBypassFlags, setCacheBypassFlagsState] =
    useState<CacheBypassFlags>(getCacheBypassFlags);

  const toggleCacheBypassFlag = (flag: keyof CacheBypassFlags) => {
    const enabled = !cacheBypassFlags[flag];
    setCacheBypassFlag(flag, enabled);
    setCacheBypassFlagsState((previous) => ({ ...previous, [flag]: enabled }));
  };

  return (
    <>
      <Text weight="semibold" style={{ marginBottom: '0.25rem' }}>
        Cache Bypass Options
      </Text>
      <Text fontSize="sm">
        Activating these options will apply to this active browser session. They
        will turn back off when you close this tab or open a new one.
      </Text>
      <Flex direction="column" gap={2} mt={2}>
        <FormField label="Skip MW Cache">
          <Switch
            id="skip_mw_cache"
            size="sm"
            inactiveLabel="Off"
            label="On"
            checked={cacheBypassFlags.bypassMwCache}
            onChange={() => toggleCacheBypassFlag('bypassMwCache')}
          />
        </FormField>
        <FormField label="Skip DBE Cache">
          <Switch
            id="skip_dbe_cache"
            size="sm"
            inactiveLabel="Off"
            label="On"
            checked={cacheBypassFlags.bypassDbeCache}
            onChange={() => toggleCacheBypassFlag('bypassDbeCache')}
          />
        </FormField>
      </Flex>
    </>
  );
};
